// extracted by mini-css-extract-plugin
module.exports = {"container":"H2eX8WdTXSHlRUkiqMsoa","label":"_2Hd30t-_uA6hUluPUL1RZi","anchor":"_2Ly_YjF6xIjMSXkP3XzKUi"};